import SVG from '../SVG'
import { IconProps } from '../types'

const StatusConfirming = (props: IconProps) => {
  const width = props.width ?? 16
  const height = props.height ?? 16
  return (
    <SVG
      {...props}
      width={width}
      height={height}
      styles={{
        color: props.color ?? '#999999',
      }}
    >
      <g clipPath="url(#clip0_5337_23224)">
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.39955 8.70362C5.1004 8.45566 4.84717 8.20644 4.65334 7.99955C4.84717 7.79266 5.1004 7.54344 5.39955 7.29548C6.14427 6.67819 7.06375 6.15957 8.00026 6.15957C8.93677 6.15957 9.85625 6.67819 10.601 7.29548C10.9001 7.54344 11.1533 7.79266 11.3472 7.99955C11.1533 8.20644 10.9001 8.45566 10.601 8.70362C9.85625 9.32092 8.93677 9.83953 8.00026 9.83953C7.06375 9.83953 6.14427 9.32092 5.39955 8.70362ZM13.0411 7.52071C13.0413 7.52092 13.0414 7.52112 12.4002 7.99955C13.0414 8.47799 13.0413 8.47818 13.0411 8.47839L13.0408 8.47885L13.0399 8.47996L13.0377 8.48289L13.0311 8.49161L13.0093 8.52C12.9909 8.54362 12.965 8.57648 12.9319 8.61725C12.8657 8.69872 12.7705 8.81222 12.6492 8.94709C12.4075 9.21579 12.0573 9.57471 11.622 9.93546C10.7743 10.6382 9.49379 11.4395 8.00026 11.4395C6.50674 11.4395 5.22623 10.6382 4.37848 9.93546C3.94326 9.57471 3.59303 9.21579 3.35131 8.94709C3.22999 8.81222 3.13477 8.69873 3.06862 8.61725C3.03552 8.57648 3.00961 8.54362 2.99125 8.52L2.96941 8.49161L2.9628 8.48289L2.9606 8.47996L2.95977 8.47885L2.95942 8.47839C2.95927 8.47818 2.95912 8.47799 3.60029 7.99955C2.95912 7.52112 2.95927 7.52092 2.95942 7.52071L2.95977 7.52025L2.9606 7.51915L2.9628 7.51621L2.96941 7.50749L2.99125 7.47911C3.00961 7.45548 3.03552 7.42262 3.06862 7.38185C3.13477 7.30038 3.22999 7.18688 3.35131 7.05201C3.59303 6.78331 3.94326 6.42439 4.37848 6.06364C5.22623 5.36095 6.50674 4.55957 8.00026 4.55957C9.49379 4.55957 10.7743 5.36095 11.622 6.06364C12.0573 6.42439 12.4075 6.78331 12.6492 7.05201C12.7705 7.18688 12.8657 7.30038 12.9319 7.38185C12.965 7.42262 12.9909 7.45548 13.0093 7.47911L13.0311 7.50749L13.0377 7.51621L13.0399 7.51915L13.0408 7.52025L13.0411 7.52071ZM3.60029 7.99955L2.95912 8.47799C2.74735 8.19418 2.74735 7.80492 2.95912 7.52112L3.60029 7.99955ZM12.4002 7.99955L13.0414 7.52112C13.2532 7.80492 13.2532 8.19418 13.0414 8.47799L12.4002 7.99955ZM8.00029 6.9998C7.44801 6.9998 7.00029 7.44752 7.00029 7.9998C7.00029 8.55209 7.44801 8.9998 8.00029 8.9998C8.55258 8.9998 9.00029 8.55209 9.00029 7.9998C9.00029 7.44752 8.55258 6.9998 8.00029 6.9998Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5337_23224">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </SVG>
  )
}

export default StatusConfirming
